import {
  PropertyFilter,
  PropertyFilterGroup,
} from "../searchSideBar/searchSideBarConnector";

/**
 * Merge Polaris-owned attribute filters back into a `PropertyFilterGroup`
 * suitable for dispatch, deciding what to do with any pre-existing
 * top-level `asin` `PropertyFilter` in `current`.
 *
 * `asinOwnedByPolaris = true`: the caller (App Shell) renders ASIN as
 * a first-class Polaris chip. `attributeFilters` already reflects the
 * user's ASIN edits, so any top-level `asin` from `current` must be
 * dropped — otherwise a chip removal is silently reverted and the
 * FilterBar's Submit stays disabled (pending query == applied query).
 *
 * `asinOwnedByPolaris = false`: the caller (Legacy sidebar) manages
 * ASIN through a separate textarea and passes `omitProperties=["asin"]`
 * to hide it from Polaris. The top-level `asin` from `current` is
 * carried forward so attribute-chip edits don't wipe the textarea's
 * ASIN.
 */
export function mergeWithPreservedAsin(
  current: PropertyFilterGroup | undefined,
  attributeFilters: PropertyFilterGroup,
  asinOwnedByPolaris: boolean
): PropertyFilterGroup {
  const preserved: Array<PropertyFilter | PropertyFilterGroup> =
    asinOwnedByPolaris
      ? []
      : (current?.filters ?? []).filter(
          (f): f is PropertyFilter =>
            f.type === "PropertyFilter" && f.propertyKey === "asin"
        );
  const filters: Array<PropertyFilter | PropertyFilterGroup> = [...preserved];
  if ((attributeFilters?.filters?.length ?? 0) > 0) {
    filters.push(attributeFilters);
  }
  return {
    type: "PropertyFilterGroup",
    filters,
    operation: "and",
  };
}
